/**
 * @returns boolean
 */
export default function (timestamp: string): boolean {
  const givenDate = new Date(timestamp);
  const currentDate = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(currentDate.getMonth() - 1);
  return givenDate < oneMonthAgo;
}
